// extracted by mini-css-extract-plugin
export default {"mCard":"hA-z","image":"iA-z","imageNoBackground":"jA-z","imageHasCategory":"kA-z","fullWidth":"lA-z"};